import { HttpInterceptorFn } from '@angular/common/http';

export const noCacheInterceptor: HttpInterceptorFn = (req, next) => {
  const noCacheUrls = ['/users/me', '/events'];
  const isNoCacheUrl = noCacheUrls.some(u => req.url.includes(u));

  if (isNoCacheUrl) {
    const noCacheReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    });
    return next(noCacheReq);
  }

  return next(req);
};
